import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TimelineMax } from 'gsap/all'
import { theme, media } from '../../styles'
const { colors } = theme

const Text = styled.div.attrs(({ shade }) => ({
  color: shade || '#FFFFFF',
}))`
  color: ${props => props.color};
  font-size: ${theme.fontSizes.medium};
  font-family: ${theme.fonts.heading};
  &:after {
    display: block;
    content: '';
    border-left: 1px solid ${props => props.color};
    height: 50px;
    margin-top: 5px;
    transform: translateX(50%);
  }
  ${media.thone`
  font-size: ${theme.fontSizes.medium};
  `}
`

export default class ScrollDown extends Component {
  static contextTypes = {
    scrollmagic: PropTypes.any,
  }

  componentDidMount() {
    // const { scrollMagic } = this.props
    // const { Scene } = scrollMagic

    // this.animation = new TimelineMax({ paused: true })
    //   .set(this.node, { css: { animation: 'none' } })
    //   .to(this.node, 2, { y: 60, opacity: 0, delay: 1 })

    // this.scene = new Scene({ triggerElement: this.node, triggerHook: 0.7 })
    // this.scene.on('enter', () => { this.animation.play() })

    // this.scene.addTo(this.context.scrollmagic)
  }

  render() {
    const { text } = colors
    return (
      <div>
        <div ref={c => { this.node = c }}>
          <Text shade={text}>scroll</Text>
        </div>
      </div>
    )
  }
}
